export type Elegible = 'elegible' | 'not-elegible' | 'period-over' | 'claimed' | 'not-started';

export const getBackgroundUrl = (elegible: Elegible) => {
  switch (elegible) {
    case 'not-elegible':
      return '/background/not-elegible.webp';
    case 'period-over':
      return '/background/period-over.webp';
    default:
      return '/background/elegibility-checker-background-full.webp';
  }
};

export const getTitle = (elegible: Elegible) => {
  switch (elegible) {
    case 'claimed':
      return 'Congratulations!';
    case 'not-elegible':
      return 'You are not eligible for the <br /> Reward Program';
    case 'period-over':
      return 'Claim Period is Over';
    case 'not-started':
      return 'Claim Period has not started yet';
    default:
      return `Congratulations!`;
  }
};
